// Notifications.js
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { getAuth } from 'firebase/auth';
import './Notifications.css'; // Add styling here

function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [token, setToken] = useState(null);

  const fetchNotifications = async () => {
    try {
      const auth = getAuth();
      const user = auth.currentUser;
      if (!user) return;
      const idToken = await user.getIdToken();
      setToken(idToken);
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/user/${user.uid}/data`,
        { headers: { Authorization: `Bearer ${idToken}` } }
      );
      const userNotifs = response.data.notifications || [];
      

      const processed = userNotifs.map((n) => {
        const raw = n.timestamp;
        let ts = null;
      
        if (raw) {
          if (typeof raw.toDate === "function") {
            // Firestore Timestamp instance
            ts = raw.toDate();
          } else if (raw._seconds !== undefined) {
            // Serialized timestamp from Firestore
            ts = new Date(raw._seconds * 1000);
          } else if (raw.seconds !== undefined) {
            // Just in case it comes as `seconds`
            ts = new Date(raw.seconds * 1000);
          } else if (typeof raw === "string") {
            ts = new Date(raw);
          }
        }
      
        return { ...n, timestamp: ts };
      });

      setNotifications(processed);
    } catch (err) {
      console.error('Error fetching notifications:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifications();
    const intervalId = setInterval(fetchNotifications, 5000);
    return () => clearInterval(intervalId);
  }, []);

  const handleNotificationClick = async (index) => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user || !token) return;
    // Optimistically mark as read in UI
    const updated = [...notifications];
    updated[index].read = true;
    setNotifications(updated);
    // Update in Firestore
    try {
      await axios.put(
        `${process.env.REACT_APP_API_BASE_URL}/user/${user.uid}/notifications`,
        { index },
        { headers: { Authorization: `Bearer ${token}` } }
      );
    } catch (err) {
      console.error('Error marking notification as read:', err);
    }
  };

  if (loading) return <p>Loading notifications...</p>;
  if (notifications.length === 0) return <p>No notifications.</p>;

  return (
    <div className="notifications-container">
      <h2>Notifications</h2>
      <ul className="notifications-list">
        {notifications.map((n, idx) => (
          <li
            key={idx}
            className={`notification-item ${n.read ? 'read' : 'unread'}`}
            onClick={() => handleNotificationClick(idx)}
          >
            <p>{n.message}</p>
            <small>
              {n.timestamp && !isNaN(n.timestamp.getTime())
                ? n.timestamp.toLocaleString()
                : 'Unknown date'}
            </small>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default Notifications;
